import { isNotNumber } from '../../utils/js.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var ValueFormat;
(function (ValueFormat) {
    ValueFormat["currency"] = "currency";
    ValueFormat["number"] = "number";
})(ValueFormat || (ValueFormat = {}));
var Align;
(function (Align) {
    Align["left"] = "left";
    Align["right"] = "right";
    Align["center"] = "center";
})(Align || (Align = {}));
/**
 * Funzione che trasforma un valore stringa in un valore numerico (eliminando anche caratteri speciali)
 */
const parse = (valore, separatore = ',') => {
    // se non specifico valore restituisco 0
    const newValue = valore || 0;
    // se è un numero lo restituisco
    if (typeof valore === 'number') {
        return valore;
    }
    // Se non specifico un separatore uso quello di default in Italia
    // Elimino tutti i caratteri tranne cifre, segni meno e separatori decimali
    const regex = new RegExp(`[^0-9-${separatore}]`, 'g');
    const unformatted = parseFloat((`${newValue}`)
        .replace(/\((.*)\)/, '-$1')
        .replace(regex, '')
        .replace(separatore, '.'));
    // ritorno il valore
    return !isNotNumber(unformatted) ? unformatted : 0;
};
const normalizza = (value, defaultValue) => (isNotNumber(Math.abs(value))
    ? defaultValue : Math.abs(value));
const toFixed = (valore, precisione) => {
    const newPrecisione = normalizza(precisione, 2);
    const power = Math.pow(10, newPrecisione);
    // moltiplica per la precisione, arrotonda correttamente
    // e poi dividi di nuovo per arrotondare correttamente
    return (Math.round(normalizza(valore) * power) / power).toFixed(newPrecisione);
};
/**
 * Funzione che trasforma il numero passato in input in un numero string formattato con la precisione indicata
 */
const format = (numero, precisione) => {
    if (numero === null) {
        return '';
    }
    // leggo il numero
    const newNumero = parse(numero);
    // leggo le opzioni passate
    const opts = {
        precisione,
        grouping: 3,
        migliaia: '.',
        decimali: ',',
    };
    // normalizza la precisione
    const usePrecision = normalizza(opts.precisione);
    // eseguo i calcoli
    const negative = newNumero < 0 ? '-' : '';
    const base = `${parseInt(toFixed(Math.abs(newNumero || 0), usePrecision), 10)}`;
    const mod = base.length > 3 ? base.length % 3 : 0;
    // formatto il numero
    return negative + (mod ? base.substr(0, mod) + opts.migliaia : '')
        + base.substr(mod).replace(/(\d{3})(?=\d)/g, `$1${opts.migliaia}`)
        + (usePrecision ? opts.decimali + toFixed(Math.abs(newNumero), usePrecision)
            .split('.')[1] : '');
};
/**
 * Calcola la precisione con default in base al formato
 */
const getPrecision = (valueFormat, precision) => {
    if (precision)
        return precision;
    if (valueFormat === ValueFormat.currency)
        return 2;
    return 0;
};
/**
 * Funzione che formatta il valore passato secondo i due formati number o currency (senza simbolo)
 * @param value
 * @param valueFormat
 * @param precision
 * @returns valore formattato
 */
const formatValue = (value, valueFormat, precision) => {
    switch (valueFormat) {
        case ValueFormat.number:
        case ValueFormat.currency:
            return format(value, getPrecision(valueFormat, precision));
    }
    return value;
};
/**
 * Funzione che formatta il valore passato secondo i due formati number o currency (senza simbolo)
 * @param value
 * @param valueFormat
 * @param precision
 * @returns
 */
const formatNumber = (value, valueFormat, precision) => `${formatValue(value, valueFormat, precision)}`;
/**
 * Funzione che formatta il valore passato secondo i due formati number o currency (con simbolo)
 */
const formatValueCurrency = (value, valueFormat, precision, currency = '€') => {
    if (!valueFormat)
        return value;
    switch (valueFormat) {
        case ValueFormat.number:
            return format(value, getPrecision(valueFormat, precision));
        case ValueFormat.currency:
            return `${currency} ${format(value, getPrecision(valueFormat, precision))}`;
    }
    return value;
};
const alignment = (valueFormat, align) => {
    if (align)
        return align;
    if (valueFormat === ValueFormat.currency || valueFormat === ValueFormat.number)
        return Align.right;
    return Align.left;
};

export { Align, ValueFormat, alignment, format, formatNumber, formatValue, formatValueCurrency, getPrecision, normalizza, parse };
